<template>
  <div
    v-if="!hasPremiumGameformat"
    class="position-relative flex-1"
    style=""
  >
    <MessageOverlaySkeleton
      class="gw_mesblock_container"
      data-tst="breakdown_table_message"
      :isBlurred="true"
      :isTopDown="true"
      style="--content-margin: auto auto auto auto; --size-title: 1.125rem"
    >
      <div class="gw_mesblock">
        <div
          class="gw_mesblock_title"
          v-html="
            $t(`messages.blockers_upper_tier_only.title`, {
              tier: `<span class='weight_700 uppercase'>${
                solElite.want_use ? 'Elite' : 'Premium'
              }</span>`,
            })
          "
        ></div>
        <router-link
          class="gw_btn-v1 gw_btn_primary clr-white uppercase mt-4 weight_500"
          :to="{
            name: 'SubscriptionOverview',
            query: { gm_type: gameformat.gm_type },
          }"
          data-tst="breakdown_table_upgrade_btn"
        >
          <i class="mdi mdi-crown text-large mr-2"></i>
          {{ $t('btn.upgrade') }}
        </router-link>
      </div>
    </MessageOverlaySkeleton>
  </div>
  <div
    v-else-if="!showFlopContent"
    class="position-relative flex-1"
  >
    <MessageOverlaySkeleton
      v-if="!showFlopContent"
      :isBlurred="true"
      class="gw_mesblock_container"
      :isTopDown="true"
      style="--content-margin: auto auto auto auto"
    >
      <MessagesGoPostflop
        class="mt-2"
        :namespace="namespace"
        :canAISolve="canAISolve"
        :title="$t(`messages.select_postflop_spot_blockers`)"
      >
      </MessagesGoPostflop>
    </MessageOverlaySkeleton>
  </div>
  <!-- --border-right-td: var(--border-bottom-row); -->
  <TableBody
    v-else
    ref="cont"
    :items="items"
    :isInfinite="false"
    scrollTrack="large-scroll-track"
    class="gw_table_small gw_table_excel table-blockers"
    style="
      --padding-th: 0 1rem 0 0.5rem;
      --padding-sortable-th: var(--padding-th);
      --padding-td: 0 0.5rem;
      --overflow-y-head: scroll;
      --overflow-y-body-scroller: scroll;
      --cursor-hover-row: default;
      --z-index-row-hover: 1;
    "
    :style="tableBodyStyle"
    @update:scroll="tooltipItem.visible = false"
    @mouseleave="tooltipItem.visible = false"
  >
    <template #head_sticky>
      <TableHead
        :sortConf="tbl_sortConf"
        :thead="thead"
        class="large-scroll-track"
        @click:th="tbl_handleSort"
      >
        <template #th_card>
          <TableHeadCell
            style="--max-width-th: 4rem; --min-width-th: 4rem; --padding: 0"
            :sortConf="tbl_sortConf"
            :item="thead.card"
            @click:event.stop="(_e, item) => tbl_handleSort(item)"
          >
            <UnSwitcherNew
              :hasText="true"
              :hasToggleThreeWay="false"
              :tab="thead.card.sortKey"
              :options="[
                { sortKey: 'card_index', text: $t('table_head.cards') },
                { sortKey: 'suit_index', text: $t('table_head.suits') },
              ]"
              idKey="sortKey"
              @click:threeway="tbl_handleSort(thead.card)"
              @click="item => tbl_handleColsSort({ item, colsSolKey: 'card' })"
            ></UnSwitcherNew>
          </TableHeadCell>
        </template>
      </TableHead>
    </template>
    <template #default="{ item, index }">
      <BlockersTableRow
        :thead="thead"
        :thActions="thActions"
        :item="item"
        :index="index"
        @mouseleave:cell="tooltipItem.visible = false"
        @mouseenter:cell="
          ({ el, action, index, value }) => setTooltip({ el, action, index, value }, item)
        "
      >
      </BlockersTableRow>
    </template>
    <template #after>
      <div
        ref="tooltip"
        :style="tooltipItem.visible ? 'opacity:1' : 'opacity:0'"
        style="position: fixed; z-index: 4; max-width: 32rem"
        class="csst_content csst_content_visible pa-2"
        v-html="tooltipItem.text"
      ></div>
    </template>
  </TableBody>
</template>

<script>
import { nextTick } from 'vue'
import UnSwitcherNew from '@/components/Switchers/UnSwitcher_new'
import MessagesGoPostflop from '@/components/Poker/Overlays/Messages/MessagesGoPostflop'
import MessageOverlaySkeleton from '@/components/Poker/Overlays/MessageOverlaySkeleton'

import TableHead from '@/components/DataTables/v2/TableHead'
import TableHeadCell from '@/components/DataTables/v2/TableHeadCell'
import TableBody from '@/components/DataTables/v2/TableBody'
import table_mix from '@/components/DataTables/table_mix'
import float_mix from '@/mixins/float_mix'
// import tier_mix from '@/mixins/tier_mix'
import BlockersTableRow from '@/components/DataTables/v2/tables/BlockersTable/BlockersTableRow'
import { getPercentageOfMax } from '@/helpers/helpers'
import { getGroupedActions } from '@/helpers/grouping'

export default {
  name: 'BlockersTable',
  components: {
    TableHead,
    TableHeadCell,
    TableBody,
    BlockersTableRow,

    UnSwitcherNew,
    MessagesGoPostflop,
    MessageOverlaySkeleton,
  },
  // mixins: [table_mix, float_mix, tier_mix],
  mixins: [table_mix, float_mix],
  props: {
    namespace: { required: true, type: String },
    canAISolve: { required: true, type: Boolean },
    actions: Array,
    blockersFrequencies: Array,
    hasPremiumGameformat: Boolean,
    gameformat: Object,
    solElite: Object,
    // allCombos: { default: () => [] },
    showFlopContent: Boolean,
    customPlayer: String,
    useHex: Boolean,
    grouping: String,
  },
  data() {
    this.tbl_persistSortKey = 'sort_blockers_table'
    this.l_sortConf = {
      sortKey: 'card_index',
      sortOrder: 'desc',
      colsSortKey: {
        card: 'card_index',
      },
    }
    // thCells:
    return {
      tbl_sortConf: this.l_sortConf,
      tooltipItem: { visible: false },
    }
  },
  methods: {
    setTooltip({ el, action, index, value }, item) {
      // console.log({ el, action, index, value })
      const textParams = {
        card: item.id,
        action: action.name,
        decrease_increase:
          value.blocked_frequency > 0
            ? this.$t('common.increase_lowercase')
            : this.$t('common.decrease_lowercase'),
        icon: `<span class="mdi ${
          item.actions[index].blocked_frequency > 0 ? 'mdi-menu-up' : 'mdi-menu-down'
        }"></span>`,
        percent_num: Math.abs(value.blocked_frequency * 100).toFixed(2),
      }

      this.tooltipItem = {
        ...item,
        textParams,
        visible: true,
        text:
          Math.abs(item.actions[index].blocked_frequency * 100).toFixed(2) === '0.00'
            ? this.$t('tooltips.blockers_cell_explanation_for_zero', textParams)
            : this.$t('tooltips.blockers_cell_explanation', textParams),
      }
      // console.log(this.tooltipItem, action)
      if (this.mobile) return
      // if ($refs) {
      nextTick(() => {
        requestAnimationFrame(() => {
          const referenceEl = el?.[0]?.$el
          const element = this.$refs.tooltip
          const boundary = this.$refs.cont?.$el
          const options = {
            placement: 'bottom',
            strategy: 'fixed',
          }
          // console.log({ referenceEl, boundary, element, options })
          if (referenceEl && element && boundary) {
            this.fl_setPositionStyle({ referenceEl, boundary, element, options })
          }
        })
      })
    },
    getSortedItems(items) {
      const res = items.map(i => i)
      const { sortKey, sortOrder } = this.tbl_sortConf
      const l_sortOrder = this.thead[sortKey].reverseSort
        ? sortOrder === 'desc'
          ? 'asc'
          : 'desc'
        : sortOrder
      //   let l_sortOrder = sortOrder
      const actionIdx = items[0]?.solution?.length - 1
      const aVal = l_sortOrder === 'desc' ? -1 : 1
      const bVal = l_sortOrder === 'desc' ? 1 : -1
      if (l_sortOrder === 'desc') {
        if (sortKey === 'summary_idx') {
          res.sort((a, b) => (a[sortKey] > b[sortKey] ? aVal : bVal))
        } else if (sortKey === 'strategy') {
          res.sort((a, b) =>
            a.solution[actionIdx]?.strategy > b.solution[actionIdx]?.strategy ? aVal : bVal,
          )
        } else {
          res.sort((a, b) => (a.hero[sortKey] > b.hero[sortKey] ? aVal : bVal))
        }
      }
      // console.log(res)
      return res
    },
  },
  computed: {
    existingBlockerActions() {
      if (!this.blockersFrequencies || !this.actions) return []
      const bFrequencies = this.blockersFrequencies
      let res = bFrequencies?.[0].actions || []
      res = res.map(ba => this.actions.find(a => a.code === ba.action))
      return res
    },
    l_actions() {
      if (!this.blockersFrequencies || !this.actions) return []
      let res = this.existingBlockerActions
      if (!this.useHex) {
        res = getGroupedActions({
          actions: res,
          grouping: this.grouping,
          groupValues: [],
          raisesFirst: false,
        })
      }
      res = res.filter(i => i)
      return res
    },
    // useHex() { return this.$store.getters.useHex },
    // grouping() { return this.$store.getters.sw_actions_grouping },
    l_blockersFrequencies() {
      let res = this.blockersFrequencies
      if (!this.useHex) {
        res = res.map(i => {
          let actions = i.actions.map((aa, idx) => ({ ...this.existingBlockerActions[idx], ...aa }))
          // console.log(this.l_actions)
          actions = getGroupedActions({
            actions,
            grouping: this.grouping,
            groupValues: ['frequency'],
            raisesFirst: false,
          })
          const r = {
            card: i.card,
            actions,
          }
          return r
        })
      }
      // console.log(res)
      return res
    },
    items() {
      if (!this.blockersFrequencies || !this.actions) return []
      const bFrequencies = this.l_blockersFrequencies

      const blockedFrequencies = bFrequencies.reduce((a, b) => {
        const rowActionsFreqs = b.actions?.reduce((aa, bb) => {
          const rr = [...aa, bb?.frequency]
          return rr
        }, [])
        const r = [...a, ...rowActionsFreqs]
        return r
      }, [])
      const min = Math.min(...blockedFrequencies)
      const max = Math.max(...blockedFrequencies)

      const minToZero = Math.abs(min)
      const maxToOne = max + minToZero

      // console.log(bFrequencies)
      const res = bFrequencies.map((i, index) => {
        const aActions = this.l_actions.map((action, aIdx) => {
          const { actions } = i
          const blocked_frequency = actions?.[aIdx]?.frequency || null
          const zeroedValue = blocked_frequency + minToZero

          const blocked_frequency_colored = getPercentageOfMax({
            max: maxToOne,
            value: zeroedValue,
          })
          const gradient = Math.round((blocked_frequency_colored * 100) / 5) * 5
          const color = `--clr-eveqeqrbl${gradient}`
          const unimportant = blocked_frequency <= 0.00014 && blocked_frequency >= -0.00014
          // console.log(blocked_frequency, unimportant)

          const aa = {
            ...action,
            blocked_frequency,
            unimportant,
            color,
          }
          return aa
        })
        const r = {
          card_index: index,

          id: i.card,
          card: i.card,
          actions: aActions,
        }
        return r
      })

      const { sortKey, sortOrder } = this.tbl_sortConf
      // let l_sortOrder = this.thead[sortKey].reverseSort ? sortOrder === 'desc' ? 'asc' : 'desc' : sortOrder
      const sortOrderDesc = sortOrder === 'desc'
      const aVal = sortOrder === 'desc' ? -1 : 1
      const bVal = sortOrder === 'desc' ? 1 : -1
      if (sortKey === 'card_index') {
        res.sort((a, b) => (a[sortKey] > b[sortKey] ? aVal : bVal))
      } else if (sortKey === 'suit_index') {
        // same in reports rep_main.ts -- todo refactor
        const cardValues = ['2', '3', '4', '5', '6', '7', '8', '9', 'T', 'J', 'Q', 'K', 'A']
        const orderColor = ['s', 'h', 'd', 'c']
        res.sort((a, b) => {
          const val_A = a.id[0]
          const val_B = b.id[0]
          const clr_A = a.id[1]
          const clr_B = b.id[1]
          if (clr_A === clr_B) {
            if (cardValues.indexOf(val_A) > cardValues.indexOf(val_B)) {
              return !sortOrderDesc ? 1 : -1
            }
            return !sortOrderDesc ? -1 : 1
          }
          if (orderColor.indexOf(clr_A) > orderColor.indexOf(clr_B)) {
            return 1
          }
          return -1
        })
      } else {
        res.sort((a, b) =>
          a.actions[sortKey]?.blocked_frequency > b.actions[sortKey]?.blocked_frequency
            ? aVal
            : bVal,
        )
      }
      // console.log(res)
      return res
    },
    showBetsIn() {
      return this.$store.getters.show_bets_in
    },
    thActions() {
      const res = {}
      if (this.actions) {
        const { l_actions } = this
        const maxWidth =
          this.showBetsIn === 'bb_and_pot' || this.showBetsIn === 'pot_and_bb' ? '10rem' : '8rem'
        l_actions.forEach((a, index) => {
          const htmlName = a?.group_display_name
            ? this.$t(`browse.${a.group_display_name}`)
            : this.getBetHtml({
                showBetsIn: this.showBetsIn,
                a,
                name: true,
              })
          res[a.id || a.code] = {
            name: htmlName,
            sortKey: index.toString(),
            cssClass: 'f-center',
            cssStyle: `--max-width-th: ${maxWidth};--padding-th: 0;`,
            tdStyle: `--max-width-td: ${maxWidth}`,
          }
        })
      }
      return res
    },
    thead() {
      const res = {
        card: {
          name: this.$t('table_head.card'),
          key: 'card',
          sortKey: this.tbl_sortConf?.colsSortKey?.card || 'card_index',
          sortKeys: ['card_index', 'suit_index'],
          reverseSort: true,
          cssClass: 'gw_table_head_cell_sticky',
          cssStyle: '--max-width-th: 4rem',
          tdStyle: '--max-width-td: 4rem',
        },
        ...this.thActions,
      }
      return res
    },
    tableBodyStyle() {
      return `--min-width-table-inner: ${
        5.5 +
        this.l_actions.length *
          (this.showBetsIn === 'bb_and_pot' || this.showBetsIn === 'pot_and_bb' ? 10 : 7)
      }rem`
    },
  },
  watch: {
    thead: {
      immediate: true,
      handler: 'tbl_setSortConf',
    },
  },
}
</script>
